import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const reports = createApi({
    reducerPath: 'reports',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getOutletCombo: builder.mutation({
            query: (param) => ({
                url: 'reports/getOutletCombo',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getLaunchingCombo: builder.mutation({
            query: (param) => ({
                url: 'reports/getLaunchingCombo',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getSaleReports: builder.mutation({
            query: (param) => ({
                url: 'reports/saleReports',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getGrab: builder.mutation({
            query: (param) => ({
                url: 'grab/grabMart',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetOutletComboMutation, useGetLaunchingComboMutation, useGetSaleReportsMutation
, useGetGrabMutation } = reports;
export default reports;